import { compose, withProps, withPropsOnChange } from 'recompose';
import { withRouter } from 'react-router';

import ShopifyIntegration from './ShopifyIntegration';
import withShopifySettings from '../../../../products/products/Shopify/withShopifySettings';
import withNotifications from '../../../../common/withNotifications';
import withShopifyConnectionSave
  from '../../../../products/products/Shopify/components/ShopifySettingsForm/withShopifyConnectionSave';
import { BRAND_USER_BASE_URL } from '../../../../constants';
import { SHOPIFY_MATCHES } from '../../../../products/products/Shopify/constants';
import withRedirectToIntegration from './withRedirectToIntegration';
import { SETTINGS } from '../constants';

export default compose(
  withRouter,
  withProps(() => ({
    baseUrl: BRAND_USER_BASE_URL,
  })),
  withShopifySettings,
  withRedirectToIntegration,
  withNotifications,
  withShopifyConnectionSave,
  withPropsOnChange(['shopifyConnectionState'], (props) => {
    if (props.shopifyConnectionState === SHOPIFY_MATCHES) {
      props.redirectToIntegration(props.baseUrl, `/shopify/${SETTINGS}`);

      return;
    }

    props.redirectToIntegration(props.baseUrl, `/shopify/${props.shopifyConnectionState}`);
  }),
)(ShopifyIntegration);
